// Envs
export const envLocal: string = 'local'
export const envStaging: string = 'staging'
export const envProduction: string = 'production'

// Donwload App link
export const DOWNLOAD_APP_LINK = 'https://jo.my/tate'
